import React from 'react';
import PropTypes from 'prop-types';

import styles from './Icon.scss';

const Icon = ({
  src,
  value,
  noBorder,
  engineType
}) => (
  <div
    className={`
      ${styles.Icon}
      ${noBorder ? styles.noBorder : ''}
      ${engineType ? styles[engineType] : ''}
    `}
  >
    {src && <i className={styles[src]} />}
    {value && <p>{value}</p>}
  </div>
);

Icon.defaultProps = {
  src: '',
  value: '',
  noBorder: false,
  engineType: ''
};

Icon.propTypes = {
  src: PropTypes.string,
  value: PropTypes.string,
  noBorder: PropTypes.bool,
  engineType: PropTypes.string
};

export default Icon;




// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js